import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Set from "@babel/runtime-corejs2/core-js/set";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import memoize from 'memoize-one';
import locale from '../locale';
import { Manager, Reference, PopperPortal } from '../core/Popper';
import createRef from '@roo/create-react-ref/createRef';
import { isFunction, isArray } from '@utiljs/is';
import '../_utils/polyfill';
import './selector.css';

var defaultFieldNames = _Object$freeze({
  title: 'title',
  children: 'children',
  value: 'value',
  label: 'label',
  disabled: 'disabled'
});

var defaultNotFoundContent = /*#__PURE__*/React.createElement("a", {
  className: "disabled",
  onClick: function onClick(e) {
    return e.preventDefault();
  }
}, "\u6682\u65E0\u6570\u636E");

function filterOptions(options, filterable, filterMethod, query, fieldNames) {
  var ret = [];

  for (var i = 0; i < options.length; ++i) {
    var raw = options[i];
    var opt = {
      value: raw[fieldNames.value || 'value'],
      label: raw[fieldNames.label || 'label'],
      disabled: !!raw[fieldNames.disabled || 'disabled']
    };

    if (!(filterable && isFunction(filterMethod) && !filterMethod(query, opt, raw))) {
      ret.push({
        raw: raw,
        opt: opt
      });
    }
  }

  return ret;
}

function filterOptionGroups(groups, filterable, filterMethod, query, fieldNames) {
  var ret = [];

  for (var i = 0; i < groups.length; ++i) {
    var group = groups[i];
    var title = group[fieldNames.title || 'title'] || '';
    var children = group[fieldNames.children || 'children'] || [];
    var subList = [];

    for (var j = 0; j < children.length; ++j) {
      var raw = children[j];
      var opt = {
        value: raw[fieldNames.value || 'value'],
        label: raw[fieldNames.label || 'label'],
        disabled: !!raw[fieldNames.disabled || 'disabled']
      };

      if (!(filterable && isFunction(filterMethod) && !filterMethod(query, opt, raw))) {
        subList.push({
          raw: raw,
          opt: opt
        });
      }
    }

    if (subList.length > 0) {
      ret.push({
        title: title,
        children: subList
      });
    }
  }

  return ret;
}

function isDef(value) {
  return value !== undefined && value !== null;
}

var CursorHoverClass = 'hover';
export var Selector = /*#__PURE__*/function (_PureComponent) {
  _inherits(Selector, _PureComponent);

  var _super = _createSuper(Selector);

  function Selector(props) {
    var _this;

    _classCallCheck(this, Selector);

    _this = _super.call(this, props); // select 框体

    _this.selectRef = null; // select 中的 input 框

    _this.inputRef = createRef(); // 下拉列表

    _this.listRef = createRef();
    _this.filterOptions = memoize(filterOptions);
    _this.filterOptionGroups = memoize(filterOptionGroups);
    _this.state = {
      focused: false,
      keyword: '',
      query: '',
      showClear: false,
      showPopover: false,
      width: undefined,
      cursorIndex: undefined
    };
    _this.showClear = _this.showClear.bind(_assertThisInitialized(_this));
    _this.hideClear = _this.hideClear.bind(_assertThisInitialized(_this));
    _this.showPopover = _this.showPopover.bind(_assertThisInitialized(_this));
    _this.hidePopover = _this.hidePopover.bind(_assertThisInitialized(_this));
    _this.handleClearAll = _this.handleClearAll.bind(_assertThisInitialized(_this));
    _this.handleInputBlur = _this.handleInputBlur.bind(_assertThisInitialized(_this));
    _this.handleInputFocus = _this.handleInputFocus.bind(_assertThisInitialized(_this));
    _this.handleInputClick = _this.handleInputClick.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleItemMouseLeave = _this.handleItemMouseLeave.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Selector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
      var _this$props = this.props,
          defaultPopupVisible = _this$props.defaultPopupVisible,
          popupVisible = _this$props.popupVisible;
      var isVisible = popupVisible || defaultPopupVisible;

      if (isVisible) {
        if (this.selectRef) {
          var _this$selectRef$getBo = this.selectRef.getBoundingClientRect(),
              width = _this$selectRef$getBo.width;

          this.setState({
            width: width,
            showPopover: true
          });
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // 调整滚动位置使悬停项在可视区域内
      var showPopover = this.state.showPopover;

      if (showPopover && this.listRef.current) {
        var list = this.listRef.current;
        var hover = list.querySelector(".".concat(CursorHoverClass));

        if (hover) {
          var windowTop = list.scrollTop;
          var windowBottom = list.scrollTop + list.clientHeight;
          var itemTop = hover.offsetTop;
          var itemBottom = hover.offsetTop + hover.clientHeight;

          if (itemTop < windowTop) {
            list.scrollTo(0, itemTop);
          }

          if (windowBottom < itemBottom) {
            list.scrollTo(0, itemBottom - list.clientHeight);
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "showClear",
    value: function showClear() {
      var clearable = this.props.clearable;

      if (clearable) {
        this.setState({
          showClear: true
        });
      }
    }
  }, {
    key: "hideClear",
    value: function hideClear() {
      this.setState({
        showClear: false
      });
    }
  }, {
    key: "showPopover",
    value: function showPopover() {
      this.setState({
        showPopover: true
      }, this.handlePopupVisibleChange.bind(this, true));
    }
  }, {
    key: "hidePopover",
    value: function hidePopover() {
      this.setState({
        showPopover: false
      }, this.handlePopupVisibleChange.bind(this, false));
    }
  }, {
    key: "handlePopupVisibleChange",
    value: function handlePopupVisibleChange(status) {
      var onPopupVisibleChange = this.props.onPopupVisibleChange;

      if (isFunction(onPopupVisibleChange)) {
        onPopupVisibleChange(status);
      }
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur() {
      var _this2 = this;

      this.setState({
        focused: false,
        keyword: ''
      }, function () {
        var onBlur = _this2.props.onBlur;

        if (isFunction(onBlur)) {
          onBlur();
        }
      });
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus() {
      this.setState({
        focused: true
      });
    }
  }, {
    key: "handleInputClick",
    value: function handleInputClick() {
      var disabled = this.props.disabled;

      if (disabled) {
        return;
      }

      if (this.selectRef) {
        var _this$selectRef$getBo2 = this.selectRef.getBoundingClientRect(),
            width = _this$selectRef$getBo2.width;

        this.setState({
          width: width,
          showPopover: true
        }, this.handlePopupVisibleChange.bind(this, true));
      } else {
        this.setState({
          showPopover: true
        }, this.handlePopupVisibleChange.bind(this, true));
      }
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var _this3 = this;

      var keyword = event.target.value; // 输入时同步 keyword & query

      this.setState({
        keyword: keyword,
        query: keyword
      }, function () {
        var onSearch = _this3.props.onSearch;

        if (onSearch) {
          onSearch(keyword);
        }
      });
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(raw, event) {
      var _this4 = this;

      if (event) {
        event.preventDefault();
      } // { value, label, disabled }


      var option = this.getOptionFromRaw(raw);
      var _this$props2 = this.props,
          value = _this$props2.value,
          multiple = _this$props2.multiple,
          rawOption = _this$props2.rawOption,
          onChange = _this$props2.onChange,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          _this$props2$fieldNam = _this$props2.fieldNames,
          fieldNames = _this$props2$fieldNam === void 0 ? defaultFieldNames : _this$props2$fieldNam;

      if (option.disabled || disabled || readOnly) {
        return;
      }

      if (isFunction(onChange)) {
        if (multiple) {
          var selected = this.getSelectedValueSet().has(option.value); // 非 rawOption 时的 value 可能包含不在 options 里的值，onChange 时将其过滤?
          // const optionValueSet = this.getOptionValueSet();
          // const oldValue = rawOption ? value : ((value || []) as PrimitiveValue[]).filter(v => optionValueSet.has(v));

          var newValue = [];

          if (selected) {
            // 取消选中
            if (isArray(value)) {
              newValue = rawOption ? value.filter(function (item) {
                return item[fieldNames.value || defaultFieldNames.value] !== option.value;
              }) : value.filter(function (v) {
                return v !== option.value;
              });
            }
          } else {
            // 新选中
            if (isArray(value)) {
              newValue = rawOption ? value.concat([raw]) : value.concat([option.value]);
            } else {
              newValue = [rawOption ? raw : option.value];
            }
          }

          onChange(newValue);
        } else {
          onChange(rawOption ? raw : option.value);
        }
      }

      var query = this.state.query;
      this.setState({
        // 清空输入框
        keyword: '',
        // 多选时下拉框保持展开
        showPopover: !!multiple,
        // 多选时保留过滤结果
        query: multiple ? query : ''
      }, function () {
        if (multiple && _this4.inputRef.current) {
          _this4.inputRef.current.focus();
        }

        if (!multiple) {
          _this4.handlePopupVisibleChange(false);
        }
      });
    }
  }, {
    key: "handleItemMouseEnter",
    value: function handleItemMouseEnter(idx) {
      this.setState({
        cursorIndex: idx
      });
    }
  }, {
    key: "handleItemMouseLeave",
    value: function handleItemMouseLeave() {
      this.setState({
        cursorIndex: undefined
      });
    }
  }, {
    key: "handleClearAll",
    value: function handleClearAll(event) {
      event.stopPropagation();
      this.setState({
        keyword: '',
        query: ''
      });
      var _this$props3 = this.props,
          multiple = _this$props3.multiple,
          onChange = _this$props3.onChange;

      if (isFunction(onChange)) {
        onChange(multiple ? [] : undefined);
      }
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      if (this.selectRef && this.selectRef.contains(event.target)) {
        return;
      }

      this.setState({
        keyword: '',
        query: '',
        showPopover: false
      }, this.handlePopupVisibleChange.bind(this, false));
    }
  }, {
    key: "handleArrowUp",
    value: function handleArrowUp() {
      var cursorIndex = this.state.cursorIndex;
      var optionList = this.getFilterdOptionList(); // 没有可激活选项

      if (optionList.every(function (_ref) {
        var opt = _ref.opt;
        return !!opt.disabled;
      })) {
        return;
      }

      if (cursorIndex !== null && cursorIndex !== undefined && cursorIndex >= 0 && cursorIndex < optionList.length) {
        for (var i = (optionList.length + cursorIndex - 1) % optionList.length;;) {
          if (!optionList[i].opt.disabled) {
            this.setState({
              cursorIndex: i
            });
            return;
          }

          i = (optionList.length + i - 1) % optionList.length;
        }
      } else {
        for (var _i = optionList.length - 1; _i >= 0; --_i) {
          if (!optionList[_i].opt.disabled) {
            this.setState({
              cursorIndex: _i
            });
            return;
          }
        }
      }
    }
  }, {
    key: "handleArrowDown",
    value: function handleArrowDown() {
      var cursorIndex = this.state.cursorIndex;
      var optionList = this.getFilterdOptionList(); // 没有可激活选项

      if (optionList.every(function (_ref2) {
        var opt = _ref2.opt;
        return !!opt.disabled;
      })) {
        return;
      }

      if (cursorIndex !== null && cursorIndex !== undefined && cursorIndex >= 0 && cursorIndex < optionList.length) {
        for (var i = (cursorIndex + 1) % optionList.length;; i = (i + 1) % optionList.length) {
          if (!optionList[i].opt.disabled) {
            this.setState({
              cursorIndex: i
            });
            return;
          }
        }
      } else {
        for (var _i2 = 0; _i2 < optionList.length; ++_i2) {
          if (!optionList[_i2].opt.disabled) {
            this.setState({
              cursorIndex: _i2
            });
            return;
          }
        }
      }
    }
  }, {
    key: "handleEnter",
    value: function handleEnter() {
      var cursorIndex = this.state.cursorIndex;
      var optionList = this.getFilterdOptionList();

      if (cursorIndex !== undefined && cursorIndex !== null && optionList[cursorIndex]) {
        var raw = optionList[cursorIndex].raw;
        this.handleItemClick(raw);
      }
    }
  }, {
    key: "handleBackspace",
    value: function handleBackspace() {// empty
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      // console.log(event.key, event.keyCode, event.charCode);
      var showPopover = this.state.showPopover;

      if (!showPopover) {
        return;
      }

      switch (event.key) {
        case 'ArrowUp':
          event.preventDefault(); // 防止整个页面的滚动

          this.handleArrowUp();
          break;

        case 'ArrowDown':
          event.preventDefault(); // 防止整个页面的滚动

          this.handleArrowDown();
          break;

        case 'Enter':
          this.handleEnter();
          break;

        case 'Backspace':
          this.handleBackspace();
          break;

        default:
          break;
      }
    }
  }, {
    key: "getFilteredOptions",
    value: function getFilteredOptions() {
      var query = this.state.query;
      var _this$props4 = this.props,
          options = _this$props4.options,
          filterable = _this$props4.filterable,
          filterMethod = _this$props4.filterMethod,
          _this$props4$fieldNam = _this$props4.fieldNames,
          fieldNames = _this$props4$fieldNam === void 0 ? defaultFieldNames : _this$props4$fieldNam;
      return this.filterOptions(options, !!filterable, filterMethod, query, fieldNames);
    }
  }, {
    key: "getFilteredOptionGroups",
    value: function getFilteredOptionGroups() {
      var query = this.state.query;
      var _this$props5 = this.props,
          options = _this$props5.options,
          filterable = _this$props5.filterable,
          filterMethod = _this$props5.filterMethod,
          _this$props5$fieldNam = _this$props5.fieldNames,
          fieldNames = _this$props5$fieldNam === void 0 ? defaultFieldNames : _this$props5$fieldNam;
      return this.filterOptionGroups(options, !!filterable, filterMethod, query, fieldNames);
    } // 拍平后的 options

  }, {
    key: "getFilterdOptionList",
    value: function getFilterdOptionList() {
      var grouped = this.props.grouped;

      if (grouped) {
        var groups = this.getFilteredOptionGroups();
        return groups.reduce(function (acc, cur) {
          return acc.concat(cur.children);
        }, []);
      }

      return this.getFilteredOptions();
    }
  }, {
    key: "getInputClassName",
    value: function getInputClassName() {
      var _this$props6 = this.props,
          disabled = _this$props6.disabled,
          size = _this$props6.size,
          inputType = _this$props6.inputType,
          multiple = _this$props6.multiple;
      var list = ['roo-input'];

      if (multiple) {
        list.push('roo-input-tag');
      }

      if (disabled) {
        list.push('disabled');
      }

      if (size) {
        var sizeMap = {
          large: 'lg',
          normal: 'md',
          small: 'sm',
          mini: 'xs'
        };
        list.push("roo-input-".concat(sizeMap[size]));
      }

      if (inputType) {
        list.push("roo-input-".concat(inputType));
      }

      return classNames(list);
    } // 选中 value 集合，用于判断 option 的选中状态

  }, {
    key: "getSelectedValueSet",
    value: function getSelectedValueSet() {
      var selectedValueSet = new _Set();
      var _this$props7 = this.props,
          value = _this$props7.value,
          rawOption = _this$props7.rawOption,
          _this$props7$fieldNam = _this$props7.fieldNames,
          fieldNames = _this$props7$fieldNam === void 0 ? defaultFieldNames : _this$props7$fieldNam;

      if (value === undefined || value === null) {
        return selectedValueSet;
      }

      if (rawOption) {
        if (isArray(value)) {
          value.forEach(function (item) {
            selectedValueSet.add(item[fieldNames.value || defaultFieldNames.value]);
          });
        } else {
          selectedValueSet.add((value || {})[fieldNames.value || defaultFieldNames.value]);
        }
      } else {
        if (isArray(value)) {
          value.forEach(function (v) {
            return selectedValueSet.add(v);
          });
        } else {
          selectedValueSet.add(value);
        }
      }

      return selectedValueSet;
    } // 将分组中 options 拍平

  }, {
    key: "getOptionsList",
    value: function getOptionsList() {
      var _this$props8 = this.props,
          _this$props8$options = _this$props8.options,
          options = _this$props8$options === void 0 ? [] : _this$props8$options,
          grouped = _this$props8.grouped,
          _this$props8$fieldNam = _this$props8.fieldNames,
          fieldNames = _this$props8$fieldNam === void 0 ? defaultFieldNames : _this$props8$fieldNam;

      if (grouped) {
        var ret = [];

        for (var i = 0; i < options.length; ++i) {
          var children = options[i][fieldNames.children || defaultFieldNames.children] || [];
          ret = ret.concat(children);
        }

        return ret;
      }

      return options;
    }
  }, {
    key: "getOptionValueSet",
    value: function getOptionValueSet() {
      var _this$props$fieldName = this.props.fieldNames,
          fieldNames = _this$props$fieldName === void 0 ? defaultFieldNames : _this$props$fieldName;
      return new _Set(this.getOptionsList().map(function (opt) {
        return opt[fieldNames.value || defaultFieldNames.value];
      }));
    } // !仅单选用
    // 单选时使用，选中项的展示内容

  }, {
    key: "getDisplayValue",
    value: function getDisplayValue() {
      var _this$props9 = this.props,
          value = _this$props9.value,
          options = _this$props9.options,
          _this$props9$fieldNam = _this$props9.fieldNames,
          fieldNames = _this$props9$fieldNam === void 0 ? defaultFieldNames : _this$props9$fieldNam,
          rawOption = _this$props9.rawOption,
          contentRenderer = _this$props9.contentRenderer;

      if (isDef(value) && !isArray(value)) {
        if (rawOption) {
          return isFunction(contentRenderer) ? contentRenderer(value) : value[fieldNames.label || defaultFieldNames.label];
        }

        if (options) {
          // 全部选项列表，分组选项拍平
          var list = this.getOptionsList();

          for (var i = 0; i < list.length; ++i) {
            var opt = list[i];
            var optValue = opt[fieldNames.value || defaultFieldNames.value];

            if (optValue === value) {
              return isFunction(contentRenderer) ? contentRenderer(opt) : opt[fieldNames.label || defaultFieldNames.label];
            }
          }
        }

        return value;
      }

      return '';
    }
  }, {
    key: "getOptionFromRaw",
    value: function getOptionFromRaw(raw) {
      var _this$props$fieldName2 = this.props.fieldNames,
          fieldNames = _this$props$fieldName2 === void 0 ? defaultFieldNames : _this$props$fieldName2;
      return {
        value: raw[fieldNames.value || defaultFieldNames.value],
        label: raw[fieldNames.label || defaultFieldNames.label],
        disabled: !!raw[fieldNames.disabled || defaultFieldNames.disabled]
      };
    }
  }, {
    key: "renderPrefixIcon",
    value: function renderPrefixIcon() {
      var prefixIcon = this.props.prefixIcon;

      if (prefixIcon) {
        return /*#__PURE__*/React.createElement("i", {
          className: classNames(['roo-icon', 'prefix-icon', "roo-icon-".concat(prefixIcon)])
        });
      }

      return null;
    }
  }, {
    key: "renderSuffixIcon",
    value: function renderSuffixIcon() {
      var _this$props10 = this.props,
          value = _this$props10.value,
          disabled = _this$props10.disabled,
          readOnly = _this$props10.readOnly,
          clearable = _this$props10.clearable,
          suffixIcon = _this$props10.suffixIcon,
          showArrow = _this$props10.showArrow;
      var _this$state = this.state,
          keyword = _this$state.keyword,
          showClear = _this$state.showClear;

      if (clearable && showClear && !(disabled || readOnly) && (keyword.length > 0 || (isArray(value) ? value.length > 0 : !!value || value === 0))) {
        return /*#__PURE__*/React.createElement("i", {
          className: classNames('roo-icon', 'addon-icon', 'roo-icon-times-circle', 'has-click'),
          onClick: this.handleClearAll,
          onMouseEnter: this.showClear
        });
      } else if (showArrow) {
        return /*#__PURE__*/React.createElement("i", {
          onClick: this.showPopover,
          className: classNames('roo-icon', 'addon-icon', _defineProperty({}, "roo-icon-".concat(suffixIcon), !!suffixIcon))
        });
      } else {
        return null;
      }
    }
  }, {
    key: "renderSingleContainer",
    value: function renderSingleContainer() {
      var _this$props11 = this.props,
          placeholder = _this$props11.placeholder,
          disabled = _this$props11.disabled,
          readOnly = _this$props11.readOnly,
          filterable = _this$props11.filterable;
      var _this$state2 = this.state,
          focused = _this$state2.focused,
          keyword = _this$state2.keyword;
      var displayValue = this.getDisplayValue();
      var cStyle = {
        flexBasis: 0,
        minWidth: '20px'
      };
      return /*#__PURE__*/React.createElement("input", {
        ref: this.inputRef,
        type: "text",
        autoComplete: "off",
        style: cStyle,
        className: this.getInputClassName(),
        disabled: disabled,
        readOnly: readOnly || !filterable,
        value: filterable && focused ? keyword : displayValue,
        placeholder: filterable && focused ? displayValue || placeholder : placeholder,
        onBlur: this.handleInputBlur,
        onFocus: this.handleInputFocus,
        onChange: this.handleInputChange,
        onMouseEnter: this.showClear,
        onMouseLeave: this.hideClear
      });
    }
  }, {
    key: "renderMultipleContainer",
    value: function renderMultipleContainer() {
      var _this5 = this;

      var _this$props12 = this.props,
          value = _this$props12.value,
          placeholder = _this$props12.placeholder,
          filterable = _this$props12.filterable,
          rawOption = _this$props12.rawOption,
          _this$props12$fieldNa = _this$props12.fieldNames,
          fieldNames = _this$props12$fieldNa === void 0 ? defaultFieldNames : _this$props12$fieldNa,
          disabled = _this$props12.disabled,
          readOnly = _this$props12.readOnly,
          contentRenderer = _this$props12.contentRenderer,
          multipleRenderer = _this$props12.multipleRenderer,
          maxTag = _this$props12.maxTag;
      var keyword = this.state.keyword;
      var cStyle = {
        flexBasis: 0,
        minWidth: '20px'
      };
      var disabledStyle = disabled ? {
        background: '#F7F8FA'
      } : undefined;

      _Object$assign(cStyle, disabledStyle);

      var tags = [];

      if (isArray(value)) {
        if (rawOption) {
          tags.push.apply(tags, _toConsumableArray(value)); //非包装
        } else {
          var optionsList = this.getOptionsList();

          var _loop = function _loop(i) {
            var val = value[i];
            var opt = optionsList.find(function (item) {
              return item[fieldNames.value || defaultFieldNames.value] === val;
            }); // value 不在 options 中需要展示吗

            if (opt) {
              tags.push(opt);
            }
          };

          for (var i = 0; i < value.length; ++i) {
            _loop(i);
          }
        }
      }

      var renderTagContent = isFunction(contentRenderer) ? contentRenderer : function (opt) {
        return opt[fieldNames.label || defaultFieldNames.label];
      };
      return /*#__PURE__*/React.createElement("div", {
        className: this.getInputClassName(),
        onMouseEnter: this.showClear,
        onMouseLeave: this.hideClear
      }, /*#__PURE__*/React.createElement("div", {
        className: "tags-box"
      }, isFunction(multipleRenderer) ? multipleRenderer(tags) : tags.map(function (item, index) {
        if (!maxTag || maxTag > index) {
          return /*#__PURE__*/React.createElement("span", {
            className: "roo-tag roo-tag-gray",
            key: item[fieldNames.value || defaultFieldNames.value]
          }, renderTagContent(item), item[fieldNames.disabled || defaultFieldNames.disabled] ? null : /*#__PURE__*/React.createElement("i", {
            className: "roo-icon roo-icon-times-circle",
            onClick: _this5.handleItemClick.bind(_this5, item)
          }));
        } else if (maxTag === index) {
          return /*#__PURE__*/React.createElement("span", {
            key: "etc-tag",
            style: {
              fontSize: '12px',
              marginTop: '-6px',
              marginLeft: '3px'
            }
          }, "...\u7B49", tags.length, "\u4E2A");
        } else {
          return null;
        }
      }), /*#__PURE__*/React.createElement("input", {
        ref: this.inputRef,
        type: "text",
        style: cStyle,
        value: keyword,
        placeholder: !value || _Array$isArray(value) && value.length === 0 ? placeholder : '',
        disabled: disabled,
        readOnly: readOnly || !filterable,
        onBlur: this.handleInputBlur,
        onFocus: this.handleInputFocus,
        onChange: this.handleInputChange
      })));
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this$props13 = this.props,
          disabled = _this$props13.disabled,
          readOnly = _this$props13.readOnly,
          popupClass = _this$props13.popupClass,
          popupStyle = _this$props13.popupStyle,
          optionRenderer = _this$props13.optionRenderer,
          notFoundContent = _this$props13.notFoundContent;
      var cursorIndex = this.state.cursorIndex; // 覆盖 roo-theme 样式

      var style = _Object$assign({
        position: 'relative',
        width: '100%',
        top: 'auto',
        left: 'auto'
      }, popupStyle);

      var selectedValueSet = this.getSelectedValueSet();
      var filteredOptions = this.getFilteredOptions();
      var list = [];

      for (var i = 0; i < filteredOptions.length; ++i) {
        var _filteredOptions$i = filteredOptions[i],
            raw = _filteredOptions$i.raw,
            opt = _filteredOptions$i.opt;
        var active = selectedValueSet.has(opt.value);
        list.push( /*#__PURE__*/React.createElement("li", {
          key: opt.value,
          className: i === cursorIndex ? CursorHoverClass : '',
          onMouseEnter: opt.disabled ? undefined : this.handleItemMouseEnter.bind(this, i),
          onMouseLeave: this.handleItemMouseLeave
        }, /*#__PURE__*/React.createElement("a", {
          className: classNames({
            'active-highlight': active,
            disabled: opt.disabled || readOnly || disabled
          }),
          "data-value": opt.value,
          onClick: this.handleItemClick.bind(this, raw)
        }, optionRenderer && isFunction(optionRenderer) ? optionRenderer(opt, raw) : opt.label)));
      }

      return /*#__PURE__*/React.createElement("ul", {
        ref: this.listRef,
        className: classNames('roo-dropdown-menu', popupClass),
        style: style
      }, list.length > 0 ? list : /*#__PURE__*/React.createElement("li", null, notFoundContent || defaultNotFoundContent));
    }
  }, {
    key: "renderGroupedOptions",
    value: function renderGroupedOptions() {
      var _this$props14 = this.props,
          disabled = _this$props14.disabled,
          readOnly = _this$props14.readOnly,
          popupClass = _this$props14.popupClass,
          popupStyle = _this$props14.popupStyle,
          optionRenderer = _this$props14.optionRenderer,
          notFoundContent = _this$props14.notFoundContent;
      var cursorIndex = this.state.cursorIndex; // 覆盖 roo-theme 样式

      var style = _Object$assign({
        position: 'relative',
        width: '100%',
        top: 'auto',
        left: 'auto'
      }, popupStyle);

      var selectedValueSet = this.getSelectedValueSet();
      var showOptionGroups = this.getFilteredOptionGroups();
      var list = [];
      var index = 0;

      for (var i = 0; i < showOptionGroups.length; ++i) {
        var group = showOptionGroups[i];
        var title = group.title,
            children = group.children;
        var subList = [];

        for (var j = 0; j < children.length; ++j) {
          var _children$j = children[j],
              raw = _children$j.raw,
              opt = _children$j.opt;
          var active = selectedValueSet.has(opt.value);
          subList.push( /*#__PURE__*/React.createElement("li", {
            key: opt.value,
            className: index === cursorIndex ? CursorHoverClass : '',
            onMouseEnter: opt.disabled ? undefined : this.handleItemMouseEnter.bind(this, index),
            onMouseLeave: this.handleItemMouseLeave
          }, /*#__PURE__*/React.createElement("a", {
            className: classNames({
              'active-highlight': active,
              disabled: opt.disabled || readOnly || disabled
            }),
            "data-value": opt.value,
            onClick: this.handleItemClick.bind(this, raw)
          }, optionRenderer && isFunction(optionRenderer) ? optionRenderer(opt, raw) : opt.label)));
          index += 1;
        }

        if (subList.length > 0) {
          list.push( /*#__PURE__*/React.createElement("li", {
            key: "group_".concat(i)
          }, /*#__PURE__*/React.createElement("div", {
            className: "dropdown-classify"
          }, /*#__PURE__*/React.createElement("h6", null, title), /*#__PURE__*/React.createElement("ul", null, subList))));
        }
      }

      return /*#__PURE__*/React.createElement("ul", {
        ref: this.listRef,
        className: classNames('roo-dropdown-menu', popupClass),
        style: style
      }, list.length > 0 ? list : /*#__PURE__*/React.createElement("li", null, notFoundContent || defaultNotFoundContent));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props15 = this.props,
          className = _this$props15.className,
          style = _this$props15.style,
          grouped = _this$props15.grouped,
          multiple = _this$props15.multiple,
          zIndex = _this$props15.zIndex,
          disablePortal = _this$props15.disablePortal;
      var _this$state3 = this.state,
          showPopover = _this$state3.showPopover,
          width = _this$state3.width;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('dropdown', className),
        style: style
      }, /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, {
        innerRef: function innerRef(node) {
          _this6.selectRef = node;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "roo-input-group has-icon",
        onClick: this.handleInputClick
      }, this.renderPrefixIcon(), multiple ? this.renderMultipleContainer() : this.renderSingleContainer(), this.renderSuffixIcon())), /*#__PURE__*/React.createElement(PopperPortal, {
        zIndex: zIndex,
        disablePortal: disablePortal,
        visible: showPopover,
        modifiers: {
          flip: {
            behavior: ['bottom', 'top']
          },
          preventOverflow: {
            enabled: false
          },
          hide: {
            enabled: false
          }
        },
        placement: "bottom-start",
        onClickOutside: this.handleClickOutside
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: width
        }
      }, grouped ? this.renderGroupedOptions() : this.renderOptions()))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // 受控
      if (props.popupVisible !== undefined && props.popupVisible !== state.showPopover) {
        return {
          showPopover: props.popupVisible,
          cursorIndex: props.popupVisible ? state.cursorIndex : undefined
        };
      } // 关闭下拉框时清空 cursor


      if (!state.showPopover) {
        return {
          cursorIndex: undefined
        };
      }

      return null;
    }
  }]);

  return Selector;
}(PureComponent);
Selector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.number), PropTypes.arrayOf(PropTypes.object)]),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  // loading: PropTypes.bool,
  placeholder: PropTypes.string,
  inputType: PropTypes.oneOf(['', 'line', 'plaintext']),
  size: PropTypes.oneOf(['large', 'normal', 'small', 'mini']),
  filterable: PropTypes.bool,
  filterMethod: PropTypes.func,
  multiple: PropTypes.bool,
  maxTag: PropTypes.number,
  rawOption: PropTypes.bool,
  showArrow: PropTypes.bool,
  clearable: PropTypes.bool,
  grouped: PropTypes.bool,
  fieldNames: PropTypes.shape({
    title: PropTypes.string,
    children: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.string
  }),
  defaultPopupVisible: PropTypes.bool,
  popupVisible: PropTypes.bool,
  disablePortal: PropTypes.bool,
  zIndex: PropTypes.number,
  optionRenderer: PropTypes.func,
  contentRenderer: PropTypes.func,
  multipleRenderer: PropTypes.func,
  suffixIcon: PropTypes.string,
  prefixIcon: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  onBlur: PropTypes.func,
  onPopupVisibleChange: PropTypes.func,
  notFoundContent: PropTypes.node
};
Selector.defaultProps = {
  options: [],
  value: undefined,
  disablePortal: false,
  disabled: false,
  readOnly: false,
  // loading: false,
  placeholder: locale.lng('Select.placeholder'),
  inputType: '',
  size: 'normal',
  defaultPopupVisible: false,
  popupVisible: undefined,
  filterable: false,
  filterMethod: undefined,
  multiple: false,
  maxTag: undefined,
  rawOption: false,
  clearable: false,
  grouped: false,
  showArrow: true,
  fieldNames: defaultFieldNames,
  optionRenderer: undefined,
  contentRenderer: undefined,
  multipleRenderer: undefined,
  zIndex: undefined,
  suffixIcon: 'chevron-down',
  prefixIcon: '',
  onChange: undefined,
  onSearch: undefined,
  onBlur: undefined,
  onPopupVisibleChange: undefined,
  notFoundContent: null
};
polyfill(Selector);
export default Selector; // TODO:
// onMouseEnter 等事件暴露
// popupVisible 受控处理